export enum ColorCapaEnum {
    PROYECTO = '#00BFFF',
    ESTRUCTURAS = '#B0C4DE',
    EN_PROCESO = '#FFFF33',
    TERMINADO = '#4CAF50',
    PROBLEMATICA = '#f44336'
}
